var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendesk-information-message',{attrs:{"color":"orange","additional-class":"white--text my-4","icon-color":"white","icon":"$alert","dense":_vm.dense}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }